import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "menu_item",
            name: "Hestia",
            key: "hestia",
            icon: <Icon fontSize="medium">bolt</Icon>,
            route: "/hestia/home",
            privacy: "private",
        },
    ];
};

export default menus;